import React from 'react';
import CreateIconComponent, { CreateIconComponentProps } from '../CreateIconComponent';

export const TruckIcon = ({ title = 'Truck', ...props }: CreateIconComponentProps): JSX.Element => (
  <CreateIconComponent title={title} viewBox="0 0 24 24" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.471 2.666H13.23c.628 0 1.138.51 1.138 1.138v.438h4.08c.323 0 .63.136.845.375l4.082 4.523c.188.209.293.48.293.762v7.556c0 .629-.51 1.138-1.138 1.138h-1.332a3.415 3.415 0 01-6.438 0H10a3.415 3.415 0 01-6.438 0h-2.09c-.63 0-1.139-.51-1.139-1.139V3.804c0-.629.51-1.138 1.138-1.138zM17.978 16.32a1.138 1.138 0 101.138 1.146v-.008l-.002-.067a1.138 1.138 0 00-1.136-1.07zm3.413 0h-.194a3.415 3.415 0 00-6.438 0h-.393v-3.788l7.025.02v3.768zm-.055-6.043l-6.97-.02v-3.74h3.576l3.394 3.76zM12.09 5.366V16.32H10a3.415 3.415 0 00-6.44 0H2.61V4.942h9.482v.424zM5.643 17.457a1.138 1.138 0 002.276 0l-.002-.066a1.138 1.138 0 00-2.274.067z"
    />
  </CreateIconComponent>
);

export default TruckIcon;
